import { FullPrayerHub } from '@api/routes/prayer-hubs/get/params';
import React from 'react';

import { CreditsSlide, CreditsSlideItem, isCreditsSlide } from './CreditsSlide';
import { PrayerHubsFeedItem } from './PrayerHubsFeedItem';

type FeedSlideItem = FullPrayerHub | CreditsSlideItem;

interface Props {
  className?: string;
  position?: 'prev' | 'current' | 'next';
  isActive?: boolean;
  data?: FeedSlideItem | null;
}

export function FeedSlide(props: Props) {
  if (isCreditsSlide(props.data)) {
    return <CreditsSlide isActive={props.isActive} />;
  }

  return <PrayerHubsFeedItem {...props} data={props.data as FullPrayerHub | null | undefined} />;
}
